<template lang="pug">
dv-autocomplete(
  v-bind="attrs"
  v-on="listeners"
  :items="addresses"
  :loading="isLoading"
  no-filter
)
  template(
    v-for="(_, name) in $scopedSlots"
    v-slot:[name]="data"
  )
    slot(
      :name="name"
      v-bind="data"
    )
  template(
    v-for="(_, name) in $slots"
    :slot="name"
  )
    slot(:name="name")
</template>

<script>
import debounce from 'lodash/debounce';
import { PER_PAGE } from '@/constants/pagination';
import DvAutocomplete from '@/packages/ui/components/inputs/DvAutocomplete.vue';

const DEBOUNCE_DELAY = 300;

export default {
  name: 'AddressInput',
  components: {
    DvAutocomplete,
  },
  props: {},
  data() {
    return {
      addresses: [],
      isLoading: false,
    };
  },
  computed: {
    attrs() {
      return {
        'item-text': 'address',
        itemText: 'address',
        'item-value': 'address',
        itemValue: 'address',
        ...this.$attrs,
      };
    },
    listeners() {
      return {
        ...this.$listeners,
        'update:search-input': this.onUpdateSearchInput,
      };
    },
  },
  watch: {},
  created() {
    this.debouncedGetAddresses = debounce(this.getAddresses, DEBOUNCE_DELAY);
    const initial = this.$attrs?.value;
    if (initial) {
      this.getAddresses(initial);
    }
  },
  methods: {
    getAddresses(query) {
      this.isLoading = true;
      this.$models.dadata
        .suggestAddresses({
          data: {
            query,
            count: PER_PAGE.twenty,
          },
        })
        .then(({ items }) => {
          this.addresses = items;
        })
        .catch(() => {
          this.$toast.error('Произошла ошибка при попытке получить данные');
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    onUpdateSearchInput(value) {
      this.debouncedGetAddresses(value);

      this.$emit('update:search-input', value);
    },
  },
};
</script>
